<template>
    <div class="template-markup">

        <el-tabs v-model="activeTemplate">

            <!-- Recipient -->
            <el-tab-pane
                v-for="(recipient, key) in emailBuilder.recipients"
                :key="`recipient_${key}`"
                :label="getMarkupLabel(recipient, key)"
                :name="`recipient_${key}`"
            >
                <email-template
                    v-model="recipient.template"
                    :html="html"
                    :key="`recipient_${key}_${recipient.id}`"
                    :recipient="recipient"
                    :recipientType="recipient.group"
                    :subject="subject"
                    :task="task"
                    :attachments="attachments"
                    :attachmentsFor="attachmentsFor"
                    :appendAttachments="appendAttachments"
                    :preselectAttachments="preselectAttachments"
                    :filterRejectedAttachments="filterRejectedAttachments"
                    :documents="documents"
                    :documentsFor="documentsFor"
                    :preselectDocuments="preselectDocuments"
                    :application-id="applicationId"
                    :load="{
						url: loadTemplateUrl,
						data: {
							action: action,
                            templateUid: data.templateUid,
                            smsUid: data.smsUid,
							recipientId: Number(_.get(recipient.id.toString().split('-'), '1', recipient.id)),
							emailSendsTo: recipient.group,
                            sendEmail: emailBuilder.sendEmail,
                            sendSms: emailBuilder.sendSms,
                            applicationId: applicationId,
							...data,
						},
					}"
                />
            </el-tab-pane>

            <template v-for="(multi, multiKey) in multiMarkup">
                <el-tab-pane
                    v-for="recipient in multi.recipients"
                    :key="`recipient_${multiKey}_${recipient.id}`"
                    :label="`${multi.type}: ${recipient.full_name}`"
                    :name="`recipient_${multiKey}_${recipient.id}`"
                >
                    <email-template
                        v-model="recipient.template"
                        :key="`recipient_${multiKey}_${recipient.id}_${_.size(multi.recipients)}`"
                        :recipient="recipient"
                        :recipientType="recipient.group"
                        :subject="subject"
                        :task="task"
                        :attachments="attachments"
                        :attachmentsFor="attachmentsFor"
                        :preselectAttachments="preselectAttachments"
                        :filterRejectedAttachments="filterRejectedAttachments"
                        :documents="documents"
                        :documentsFor="documentsFor"
                        :appendAttachments="appendAttachments"
                        :application-id="applicationId"
                        :load="{
							url: loadTemplateUrl,
							data: {
								action: multi.action,
                                templateUid: emailBuilder.templateUid,
                                smsUid: emailBuilder.smsUid,
								recipientId: Number(_.get(recipient.id.toString().split('-'), '1', recipient.id)),
								emailSendsTo: recipient.group,
                                sendEmail: emailBuilder.sendEmail,
                                sendSms: emailBuilder.sendSms,
                                applicationId: applicationId,
								...multi.data,
							},
						}"
                    />
                </el-tab-pane>
            </template>
        </el-tabs>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import EmailTemplate from "@ambition/components/messages/EmailTemplate"

export default {
    name: "EmailMarkupMulti",
    components: {
        EmailTemplate,
    },
    props: {
        applicationId: {
            type: [Number, String],
            required: false
        },
        data: {
            required: false,
            type: Object,
            default: function () {
                return {}
            },
        },
        action: {
            required: false,
            type: [String],
        },
        html: {
            type: String,
            required: false,
            default: "",
        },
        subject: {
            required: false,
            type: [Boolean, Object],
            default: true,
        },
        task: {
            required: false,
            type: [Boolean],
            default: true,
        },
        attachments: {
            required: false,
            type: [Boolean],
            default: true,
        },
        attachmentsFor: {
            required: false,
            type: [Object],
            default: function () {
                return {}
            },
        },
        preselectAttachments: {
            required: false,
            type: [Array],
            default: function () {
                return []
            },
        },
        filterRejectedAttachments: {
            required: false,
            type: [Boolean],
            default: false,
        },
        appendAttachments: {
            required: false,
            type: [Array],
            default: function () {
                return []
            },
        },
        documents: {
            required: false,
            default: false,
            type: [Boolean],
        },
        documentsFor: {
            required: false,
            type: [Object],
            default: function () {
                return {}
            },
        },
        preselectDocuments: {
            // required: false,
            type: Array,
            default: function () {
                return []
            }
        },
        multiMarkup: {
            required: false,
            type: [Array],
            default: function () {
                return []
            },
        },
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            templatesLoaded: "builderEmail/checkTemplatesLoaded"
        }),
    },
    data() {
        return {
            activeTemplate: "recipient_0",
            loadTemplateUrl: "/admin/settings/email-templates/get-merged-template",
        }
    },
    watch: {
        multiMarkup: {
            handler(multiMarkup) {
                let extraRecipients = []
                multiMarkup.forEach(multi => {
                    multi.recipients.forEach(recipient => {
                        extraRecipients.push(recipient)
                    })
                })
                this.emailBuilder.extraRecipients = extraRecipients
            },
            deep: true
        },
        emailBuilder: {
            handler(email) {
                this.$emit("input", email)
            },
            immediate: true,
            deep: true,
        },
    },
    mounted() {
    },
    methods: {
        getRandomKey() {
            return Math.random().toString(5).replace(/[^a-z]+/g, '').substr(0, 5)
        },
        getMarkupLabel(recipient, index) {
            return `${recipient.groupName}: ${recipient.full_name}`
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
